export function SpiderIcon({ className }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <ellipse cx="12" cy="13" rx="3" ry="4" fill="currentColor" stroke="none" />
      <circle cx="12" cy="7.5" r="2" fill="currentColor" stroke="none" />
      <path d="M9.5 10 L5 7 L3 9" />
      <path d="M9 12 L4 12 L2.5 14" />
      <path d="M9 14 L4.5 16 L3.5 18" />
      <path d="M10 16 L6.5 19 L6 21" />
      <path d="M14.5 10 L19 7 L21 9" />
      <path d="M15 12 L20 12 L21.5 14" />
      <path d="M15 14 L19.5 16 L20.5 18" />
      <path d="M14 16 L17.5 19 L18 21" />
    </svg>
  );
}
